module.exports = __webpack_public_path__ + "static/media/Megan Piferi Headshot.a06b6b33.png";